import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConnectConnectorsService } from 'app/connect/core/connect-connectors.service';
import { UtilsService } from 'app/environment/services/utils.service';
import { CryptoDataService } from '../../../core/services/crypto.data.service';
import { NgForm } from '@angular/forms';
import { BzgToastService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthCodeGrantService } from 'app/connect/auth-code-grant/auth-code-grant.service';
import { AuthCodeGrantComponent } from 'app/connect/auth-code-grant/auth-code-grant.component';
import { CredentialTokenOauth } from 'app/connect/auth-code-grant/core/CredentialTokenOauth';
import { IConnector, IConnectorField, IConnectorMetadata, IConnectorType, IInterfaceConnector } from 'app/connect/core/IConnector';
import { IConnectorAuthenticationMethod } from 'app/connect/core/IConnectorAuthenticationMethod';

@Component({
  selector: 'connectors-interface',
  templateUrl: 'connectors-interface.component.html',
  styleUrls: ['connectors-interface.component.scss']
})
export class ConnectorsInterfaceComponent {

  @Input() selectedConnector: IInterfaceConnector;
  @Input() selectedConnectorType: IConnectorType;
  @Input() displayName: string;
  @Input() metadata: IConnectorMetadata;
  @Input() description: string;

  @ViewChild('connectorForm', { static: false}) connectorForm: NgForm;
  @ViewChild('authcodegrant', { static: false}) authcodegrant: AuthCodeGrantComponent;

  public selectedAuthenticationMethod: IConnectorAuthenticationMethod;
  public selectedAuthenticationMethodMetadata: { [key: string]: any };
  public availableAuthenticationMethods: Array<IConnectorAuthenticationMethod>;

  public systemProperties: Array<IConnectorField>;
  public authenticationProperties: Array<IConnectorField>;

  private _authPropertiesValuesDictionary = {};
  private _systemPropertiesValuesDictionary = {};
  public selectedTab: number = 0;
  private redirecUrl: string;

  constructor(private _connectConnectorsService: ConnectConnectorsService, public utilsService: UtilsService,
    private _cryptoDataService: CryptoDataService, private _toastService: BzgToastService, private _translateService: TranslateService,
    private authCodeGrantService: AuthCodeGrantService) { }


  async ngOnChanges() {
    //this.selectedTab = 0;
    this._authPropertiesValuesDictionary = {};
    this._systemPropertiesValuesDictionary = {};
    this.availableAuthenticationMethods = this.selectedConnectorType.systemDefinition.authentications.filter(f => f.properties.length > 0 || f.name == "none");
    _.forEach(this.availableAuthenticationMethods, (method: IConnectorAuthenticationMethod) => {
      if (this.metadata.authentications[method.authenticationtype] &&
        !_.isEmpty(this.metadata.authentications[method.authenticationtype])) {
        method.properties = _.values(_.transform(
          this.metadata.authentications[method.authenticationtype],
          (result: any, value: any, key) => {
            value['name'] = key;
            result[key] = value;
          }, {}));
      }
    });
    if (this.selectedConnector.content.authenticationname === 'OAuth2 Authentication' &&
      _.find(this.selectedConnector.content.authentication, { key: 'grant_type', value: 'client_credentials' })) {
      this.selectedAuthenticationMethod = _.find(this.availableAuthenticationMethods, { name: 'oauth2_client_credential' });
    } else if (this.selectedConnector.content.authenticationname === 'OAuth2 Authentication' &&
      _.find(this.selectedConnector.content.authentication, { key: 'response_type', value: 'code' })) {
      this.selectedAuthenticationMethod = _.find(this.availableAuthenticationMethods, { name: 'oauth2_authorization_code_grant' });
    } else {
      this.selectedAuthenticationMethod = _.find(this.availableAuthenticationMethods,
        { name: this.selectedConnector.content.authenticationname });
    }

    if (!this.selectedAuthenticationMethod) {
      this.selectedAuthenticationMethod = _.find(this.availableAuthenticationMethods,
        { name: "none" });
    }

    if (this.selectedAuthenticationMethod) {
      this.selectAuthType(this.selectedAuthenticationMethod);
    }

    _.forEach(this.selectedConnector.content.systemproperties, (property) => {
      if (property) {
        this._systemPropertiesValuesDictionary[property.key] = property.value;
      }
    });

    const propertyValue = {};
    _.forEach(this.selectedConnector.content.authentication, (property) => {
      if (property) {
        propertyValue[property.key] = property.value;
      }
    });
    if (this.selectedAuthenticationMethod) {
      this._authPropertiesValuesDictionary[this.selectedAuthenticationMethod.authenticationtype] = propertyValue;
    }

    this._setSystemProperties();
    this.redirecUrl = await this.authCodeGrantService.getServerUrl();
    this._setAuthenticationProperties();
  }

  public selectAuthType(authenticationMethod: IConnectorAuthenticationMethod) {
    this.selectedAuthenticationMethod = _.find(this.availableAuthenticationMethods,
      { authenticationtype: authenticationMethod.authenticationtype });
    this.selectedAuthenticationMethodMetadata = this.metadata.authentications[authenticationMethod.authenticationtype];
    this._setAuthenticationProperties();
  }

  public updateSelectedConnectorProperties(save?: boolean): boolean {
    let ok = true;
    if (save)
      ok = this.validateProperties(this.authenticationProperties);
    if (ok) {
      if(!this.selectedConnector.content.systemproperties){
        this.selectedConnector.content.systemproperties = [];
      }

      _.forEach(this.systemProperties, (property) => {
        const connectorProperty = this.selectedConnector.content.systemproperties.find(item => item.key === property.name);
      if (connectorProperty)
        connectorProperty.value = property.value;
      else
        this.selectedConnector.content.systemproperties.push({key: property.name,value: property.value})
      });


      if (this.selectedAuthenticationMethod) {
        if (this.selectedAuthenticationMethod.authenticationtype === 'oauth2_client_credential'
          || this.selectedAuthenticationMethod.authenticationtype === 'oauth2_authorization_code_grant')
          this.selectedConnector.content.authenticationname = 'OAuth2 Authentication';
        else
          this.selectedConnector.content.authenticationname = this.selectedAuthenticationMethod.name;

        if (this.selectedAuthenticationMethod.authenticationtype === 'oauth2_authorization_code_grant') {
          if (this.authcodegrant.credentialTokenOauth && save) {
            this.selectedConnector.content.credentialTokenOauth =  this.authcodegrant.credentialTokenOauth;
          }
        }
      }
      else {
        this.selectedConnector.content.authenticationname = 'none'
      }


      if (this.authenticationProperties && this.authenticationProperties.length > 0) {
        this.selectedConnector.content.authentication = [];
        _.forEach(this.authenticationProperties, (property) => {
          if (property.value !== undefined) {

            this.selectedConnector.content.authentication.push(
              {
                'key': property.name,
                'value': property.value
              }
            )
          }

        });
      }
    }
    return ok;
  }

  public async getEncryptedPasswords(): Promise<IConnector> {
    const newConnector: IInterfaceConnector = _.cloneDeep(this.selectedConnector);
    if (newConnector.content.systemproperties) {
      for (let i = 0; i < this.systemProperties.length; i++) {
        const property = this.systemProperties[i];
        const connectorProperty = newConnector.content.systemproperties.find(item => item.key === property.name);
        connectorProperty.value = property.value;
      }
    }

    newConnector.content.authentication = [];
    for (let i = 0; i < this.authenticationProperties.length; i++) {
      const property = this.authenticationProperties[i];
      if (property.value !== undefined) {
        const newAuthProperty = {
          'key': property.name,
          'value': property.value
        };
        if (property.passwordmode) {
          newAuthProperty.value = await this._cryptoDataService.encryptStringPromise(newAuthProperty.value);
        }
        newConnector.content.authentication.push(
          newAuthProperty
        );
      }
    }
    return newConnector;
  }

  public isValid(): boolean {
    return !this.connectorForm || this.connectorForm.valid;
  }

  private _setSystemProperties() {
    this.systemProperties = [];

    if (this.selectedConnectorType.systemDefinition.properties) {
      _.forEach(this.selectedConnectorType.systemDefinition.properties, (property) => {
        this.systemProperties.push({
          name: property.name,
          value: this._systemPropertiesValuesDictionary[property.name],
          required: property.required,
          type: property.datatype,
          passwordmode: this.metadata.connectorParameter.passwordmode,
          propertyvalues: property.propertyvalues
        });
      });
    }
  }

  private _setAuthenticationProperties() {
    this.authenticationProperties = [];

    if (this.selectedAuthenticationMethod) {
      _.forEach(this.selectedAuthenticationMethod.properties, async (property) => {
        this.authenticationProperties.push({
          name: property.name,

          value: property.name != "redirect_uri" ? (this._authPropertiesValuesDictionary[this.selectedAuthenticationMethod.authenticationtype] &&
            this._authPropertiesValuesDictionary[this.selectedAuthenticationMethod.authenticationtype][property.name] ?
            this._authPropertiesValuesDictionary[this.selectedAuthenticationMethod.authenticationtype][property.name] :
            property.defaultValue || '') : this.redirecUrl,


          passwordmode: property.passwordmode || property.type === 'password',
          required: property.required,
          readonly: property.readonly,
          type: property.datatype === '' || property.datatype === null ? 'text' : property.datatype
        });
      });

      ///Validate extra parameters in Oauth2 code grant!
      if (this._authPropertiesValuesDictionary[this.selectedAuthenticationMethod.authenticationtype] && this.authenticationProperties.length > 0) {
        let propertiesShow = this.authenticationProperties;
        let faltantes: any[] = [];
        let propertiesList: any[] = this.dictonaryToArray(this._authPropertiesValuesDictionary[this.selectedAuthenticationMethod.authenticationtype]);
        propertiesList.forEach(element => {
          if (!propertiesShow.some(p => p.name == element.name)) {
            faltantes.push(element);
          }
        });
        faltantes.forEach(el => {
          propertiesShow.push({
            name: el.name,
            value: el.value,
            passwordmode: false,
            required: true,
            readonly: false,
            type: 'text',
            canDelete: true
          });
        })
      // add redirect url
      this.authenticationProperties.forEach(prop => {
        if (prop.name == "redirect_uri") {
          prop.value = this.redirecUrl;
        }
      })
      }
    }
  }
  async decrypProperties(properties: Array<IConnectorField>, _cryptoDataService, callback) {
    for (let i = 0; i < properties.length; i++) {
      let prop = properties[i];
      if (prop.passwordmode) {
        prop.value = await this._cryptoDataService.decryptString(prop.value);
      }
    }
    callback();
  }

  dictonaryToArray(dictionay): any[] {
    var array = [];
    for (var key in dictionay) {
      if (dictionay.hasOwnProperty(key)) {
        array.push({ name: key, value: dictionay[key] });
      }
    }
    return array;
  }

  onSSLInput(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.selectedConnector.content.sslfile = reader.result.toString().split(',')[1];
    };
    this.selectedConnector.content.sslFileName = file.name;

  }

  needAuthorization() {
    if (this.selectedAuthenticationMethodMetadata && this.selectedAuthenticationMethodMetadata["response_type"]
      && this.selectedAuthenticationMethodMetadata["response_type"]["defaultValue"]) {
      return this.selectedAuthenticationMethodMetadata["response_type"]["defaultValue"] == "code";
    }
    return false;
  }

  authenticated() {
    let ok = false;
    if (this.authcodegrant && this.authcodegrant.credentialTokenOauth) {
      let credentialTokenOauth: CredentialTokenOauth = new CredentialTokenOauth(this.authcodegrant.credentialTokenOauth);
      ok = credentialTokenOauth.isValidToken();
    }
    if (!ok && this.selectedConnector && this.selectedConnector.content && this.selectedConnector.content.credentialTokenOauth) {
      let credentialTokenOauth: CredentialTokenOauth = new CredentialTokenOauth(this.selectedConnector.content.credentialTokenOauth);
      ok = credentialTokenOauth.isValidToken();
    }
    return ok;
  }

  authorize() {
    this.decrypProperties(this.authenticationProperties, this._cryptoDataService, () => {
      if (this.validateProperties(this.authenticationProperties)) {
        let oath2CodeGrantURL = this.buildPetition(this.authenticationProperties);
        let propertiesList = this.authenticationProperties.map(function (m) {
          return { "key": m.name, "value": m.value };
        });

        this.authcodegrant.openWindow(oath2CodeGrantURL, propertiesList);
      }
    });
  }

  validIgnoreProperties(name: string) {
    var ignoreProper = ["auth_url", "token_url", "client_secret"];
    return !ignoreProper.some(p => p == name);
  }

  buildPetition(properties: Array<IConnectorField>) {
    let url = properties.find(pro => pro.name == "auth_url").value;
    //Add properties
    let parameters;
    properties.filter(pro => this.validIgnoreProperties(pro.name)).forEach(async f => {
      var param = f.name + "=" + f.value;
      if (parameters) {
        parameters = parameters + "&" + param
      } else {
        parameters = param;
      }
    });
    return url + "?" + parameters;
  }

  validateProperties(properties: Array<IConnectorField>) {
    let ok = true;
    if (properties) {
      properties.forEach(prop => {
        if (prop.required) {
          if (!prop.value) {
            ok = false;
            this._translateService.get('GLOBAL.IS_REQUIRED_FIELD').subscribe((message: string) => {
              this._toastService.open(
                prop.name + message,
                {
                  type: 'error',
                  duration: 0,
                  verticalPosition: 'top',
                  horizontalPosition: 'right'
                });
            });
          }
        }
      })
    }
    return ok;
  }


  addItem() {
    let item: IConnectorField = {
      name: "",
      type: "text",
      passwordmode: false,
      required: true,
      canDelete: true
    }
    this.authenticationProperties.push(item);
  }
  deleteItem() {
    const cantToDelete = this.authenticationProperties.filter(prop => prop.selected).length;
    for (let cant = 0; cant < cantToDelete; cant++) {
      for (let i = 0; i < this.authenticationProperties.length; i++) {
        if (this.authenticationProperties[i].selected) {
          this.authenticationProperties.splice(i, 1);
          break;
        }
      }
    }
  }
  showTrash() {
    return this.authenticationProperties.some(prop => prop.selected);
  }

  copyToclipboard(value) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this._translateService.get('GLOBAL.TEXT_COPIED').subscribe((message: string) => {
      this._toastService.open(
        message,
        {
          type: 'info',
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'right'
        });
    });
  }

  hasSystemProperties() {
    let hasProperties = false;
    if (this.systemProperties && this.systemProperties.length > 0) {
      hasProperties = true;
    }
    return hasProperties;
  }

  hasDefaultValue(item: IConnectorField) {
    let hasValues = false;
    if (item.propertyvalues && item.propertyvalues.length > 0){
      hasValues = true;
    }
    return hasValues;
  }
}
